var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpDarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41291 5.53791C9.0468 5.90403 8.4532 5.90403 8.08709 5.53791L5 2.45083L1.91291 5.53791C1.5468 5.90403 0.953204 5.90403 0.587088 5.53791C0.220971 5.1718 0.220971 4.5782 0.587088 4.21209L4.33709 0.462088C4.7032 0.0959711 5.2968 0.0959711 5.66291 0.462088L9.41291 4.21209C9.77903 4.5782 9.77903 5.1718 9.41291 5.53791Z",
    fill: "#A3ACB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDarker);
export default __webpack_public_path__ + "static/media/arrowUpDarker.051a4df2da1f8e9510f9d7f9cbf6cc00.svg";
export { ForwardRef as ReactComponent };